/**
 * Id de una línea de detalle o de una referencia de pedido.
 *
 * Antes se hacía con la hora a secas, y dos cosas creadas en el mismo milisegundo salían con el
 * mismo id. Como el detalle se guarda en una columna jsonb y el id viaja dentro, quedaban
 * documentos con dos líneas indistinguibles: editar una abría las dos, borrar una borraba las
 * dos (ver la migración `fix_duplicated_detail_line_ids` del backend, que arregló 102).
 *
 * Es el mismo `plugins/unique-id.js` de frontend_vite. Se conserva la forma —«_» y la hora—
 * porque el id es una cadena opaca que el servidor guarda tal cual; lo único que cambia es que
 * ya no se repite: cuando dos caen en el mismo milisegundo, a la segunda se le añade un contador.
 */
let ultimo = 0
let seguido = 0

export function nuevoId(prefijo = '_') {
  const ahora = Date.now()
  if (ahora === ultimo) {
    seguido += 1
  } else {
    ultimo = ahora
    seguido = 0
  }
  return seguido === 0 ? `${prefijo}${ahora}` : `${prefijo}${ahora}_${seguido}`
}

export default nuevoId
